/** Where the console's API is mounted on the service: the external API, for signed-in staff (ADR-0006). */
export const SERVICE_API = '/external/v1';

/**
 * The service returns its own resources (a Design Image, an aerial crop) as paths such as
 * `/external/v1/designs/{id}/image`. Only those are loaded: an absolute, protocol-relative or `javascript:` URL is
 * never fetched with the staff user's token, whatever the response says, and neither is a `.` or `..` segment, which
 * would lead elsewhere on the service.
 */
export const isServicePath = (path: string): boolean =>
    /^\/external\/v1\/[\w.~/-]+$/.test(path) &&
    !path.split('/').some((segment) => segment === '.' || segment === '..');
